import React, { useEffect, useState } from "react";
import { Typography, Grid, makeStyles } from "@material-ui/core";
import Axios from "axios";
import Summary from "./summary/Summary";
import RecentValuations from "./recentValuations/RecentValuations";
import RecentMessages from "./recentMessages/RecentMessages";
import Charts from "./charts/Charts";
import { shallowEqual, useSelector } from "react-redux";
import { selectUser } from "../../features/data/user/userSlice";

const useStyles = makeStyles(() => ({
  divider: {
    fontSize: 20,
    color: "#757575",
    marginRight: "10px",
    marginLeft: "10px",
  },
  titleTypo: {
    fontSize: 30,
    fontWeight: 800,
    marginTop: 10,
    marginBottom: 20,
  },
  captionTypo: { fontSize: "15px", color: "#757575" },
}));

const Dashboard = (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState();
  const [dashboardData, setDashboardData] = useState();
  const { user } = useSelector(selectUser, shallowEqual);

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = () => {
    setLoading(true);
    var headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Accept: "application/json;charset=UTF-8",
      Authorization: localStorage.getItem("login"),
    };
    Axios.get(process.env.REACT_APP_API_URL + "/dashboard", {
      headers: headers,
    })
      .then((res) => {
        if (typeof res.status !== "undefined") {
          if (res.status === 200) {
            setDashboardData(res.data.data);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Grid container direction='column' style={{ padding: 10 }}>
      <Grid item>
        <Grid container direction='row' justifyContent='flex-start' alignItems='center'>
          <Typography className={classes.titleTypo}>داشبورد</Typography>
          <Typography className={classes.divider}>|</Typography>
          <Typography className={classes.captionTypo}>گزارشات</Typography>
        </Grid>
      </Grid>

      <Grid container justifyContent='flex-start' alignItems='flex-start'>
        <Summary
          loading={loading}
          summary={{
            myValuationsCount: dashboardData?.user_valuation_count,
            allValuationsCount: dashboardData?.all_valuation_count,
            activeUsersCount: dashboardData?.user_count,
          }}
        />
      </Grid>

      <Grid container direction='row'>
        <Grid item xs={12} lg={5}>
          <RecentValuations loading={loading} recentValuations={dashboardData?.latest_valuations} />
        </Grid>

        <Grid item xs={12} lg={7}>
          <Grid container direction='column'>
            <Grid item xs={12}>
              <Grid container direction='row'>
                <Charts
                  loading={loading}
                  charts={{
                    myValuationsChartData: dashboardData?.user_valuation_chart,
                    allValuationsChartData: dashboardData?.all_valuation_chart,
                  }}
                />
              </Grid>
              {(user.role === "user" || user.role === "admin" || user.role === "read_only") && (
                <Grid container direction='column'>
                  <RecentMessages loading={loading} recentMessages={dashboardData?.latest_messages} />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Dashboard;
